import { createContainer } from '@dbk-legacy/muster/react';

import merge from 'lodash/merge';
//import Device from 'react-native-device-detection';
const Device = require('react-native-device-detection');

import AssetPosition from './asset-position';

export let defaultRowFragment = {
  secID: true,
  name: true,
  currency: true,
  quantity: true,
  marketValue: true,
  unrealisedGL: true,
  unrealisedGLPercent: true,
  proportion: true,
  availableBalance: true,
  accruedInterest: true,
  balance: true,
  depositeAmount: true
};

if (Device.isTablet) {
  defaultRowFragment = merge(defaultRowFragment, {
    isin: true,
  })
}

export const defaultAssetDataFragment = {
  static: {
    options: true,
  },
};

export function factory({
  component = AssetPosition,
  assetDataFragment = defaultAssetDataFragment,
  assetDataFragmentExtend,
  rowFragment = defaultRowFragment,
  rowFragmentExtend,
} = {}) {
  let resultingRowFragment = rowFragment;

  if (rowFragmentExtend) {
    resultingRowFragment = Object.assign({}, resultingRowFragment, rowFragmentExtend);
  }

  let resultingAssetDataFragment = assetDataFragment;

  if (assetDataFragmentExtend) {
    resultingAssetDataFragment = Object.assign(
      {},
      resultingAssetDataFragment,
      assetDataFragmentExtend
    );
  }

  return createContainer({
    $fragments: {
      assetData: resultingAssetDataFragment,
      row: resultingRowFragment,
    },
  }, ({ assetData, row }) => {
    const { currency, ...restRow } = row;
    const { static: uiStatic, ...restAssetData } = assetData;

    return {
      row: {
        positionCurrency: currency,
        ...restRow,
      },
      columnWidths: uiStatic.options.map(({ width }) => width),
      ...restAssetData,
    };
  })(component);
}

export default factory();
